import React from "react";
import { connect } from "react-redux";

import { getLists, setLists } from "../reducer";
import api from "../../../lib/api";

/**
 * @deprecated
 */
class PrefetchLists extends React.Component {
  state = {
    isFetching: false
  };

  safeSetState = (obj, cb = () => {}) => {
    if (!this._mounted) return;

    this.setState(obj, cb);
  };

  componentDidMount() {
    this._mounted = true;

    if (!this.props.lists.fetched && !this.state.isFetching) {
      this.setState({
        isFetching: true
      });

      api.get("/lists").then(response => {
        this.safeSetState({ isFetching: false }, () =>
          this.props.setLists(response.data)
        );
      });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    if (!this.props.lists.fetched) return null;

    return this.props.children;
  }
}

export default connect(
  state => ({ lists: getLists(state) }),
  { setLists }
)(PrefetchLists);
